import React from "react";
import {autobind} from "core-decorators";
import {Button, Typography} from "antd";
import {MailOutlined, UserOutlined} from "@ant-design/icons";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import _isEmpty from "lodash/isEmpty";

import "./AccountPopover.scss";
import {paths} from "@/routes";
import Store from "@/stores";

export interface IAccountPopoverProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class AccountPopover extends React.Component<IAccountPopoverProps> {
  @observable signingOut: boolean = false;

  goToEnsemble() {
    const {history} = this.props.store!;
    history.history.push(paths.selectedEnsemble());
  }

  goToEnsembles() {
    const {history} = this.props.store!;
    history.history.push(paths.ensembles());
  }

  goToSubscription() {
    const {history} = this.props.store!;
    history.history.push(paths.subscription());
  }

  async signOut() {
    const {history, session} = this.props.store!;
    this.setSigningOut(true);
    await session.signOut();
    this.setSigningOut(false);
    history.history.push(paths.signIn());
  }

  @action
  setSigningOut(value: boolean) {
    this.signingOut = value;
  }

  public render() {
    const {session} = this.props.store!;
    return (
      <div className="AccountPopover">
        <div className="item title">
          <UserOutlined />
          <Typography.Title level={4}>Account</Typography.Title>
        </div>
        <div id="email-item" className="item">
          <MailOutlined />
          {session.voicefulUser!.email}
        </div>
        <div className="separator"></div>
        <div className="item">
          <Button type="primary" block size="small" onClick={this.goToSubscription}>
            Subscription
          </Button>
        </div>
        {session.isEnsembleConductor && (
          <div className="item">
            <Button type="primary" block size="small" onClick={this.goToEnsemble}>
              Ensemble
            </Button>
          </div>
        )}
        {!_isEmpty(session.ensembles) && (
          <div className="item">
            <Button type="primary" block size="small" onClick={this.goToEnsembles}>
              My Ensembles
            </Button>
          </div>
        )}
        <div className="item">
          <Button type="primary" danger block size="small" onClick={this.signOut} loading={this.signingOut}>
            Sign out
          </Button>
        </div>
      </div>
    );
  }
}
